import { reactive, watch, computed, nextTick } from "vue";
import { useStore } from "vuex";
import {
  YES_NO_OPTIONS,
  FIXED_OPTIONS,
  configFieldEntries,
  isSelectField,
} from "@/scripts/Utilities/ConfigFields.js";

export default function useUtilityDropdownsContainer(props) {
  const store = useStore();
  const config = computed(() => store.getters["utilities/getConfig"]);
  const timezones = computed(() => store.getters["timezones/getTimezones"]);

  const form = reactive({});

  const optionsFor = (key) => {
    if (key === "timezone") return timezones.value;
    return FIXED_OPTIONS[key] ?? YES_NO_OPTIONS;
  };

  const dropdownConfigs = computed(() =>
    configFieldEntries(config.value).reduce((fields, [key, field]) => {
      if (isSelectField(key, field)) {
        fields[key] = { title: `${field.title}:`, options: optionsFor(key) };
      }
      return fields;
    }, {})
  );

  let isInitializing = false;

  const resetForm = () => {
    if (!config.value) return;
    isInitializing = true;

    Object.keys(dropdownConfigs.value).forEach((key) => {
      form[key] = config.value[key].value;
    });

    nextTick(() => {
      isInitializing = false;
    });
  };

  watch(
    () => ({ ...form }),
    (newForm, oldForm) => {
      if (isInitializing) return;
      Object.keys(newForm).forEach((key) => {
        if (newForm[key] !== oldForm[key]) {
          props.updateFieldObject(key, newForm[key]);
        }
      });
    },
    { deep: true }
  );

  return { form, dropdownConfigs, config, resetForm };
}
